module.exports = __webpack_public_path__ + "static/media/accesspro.5b78c3c6.png";